module.exports = __webpack_public_path__ + "img/home6.8165fb12.jpg";